import { CategoryHighlight, GetCategoryResponseItem } from "../api/response/EMarketplace";

export type CategoryChain = Category[];

export class Category {
    readonly categoryID: number;
    readonly nameEN: string;
    readonly nameLocal: string;
    readonly subCategories: Category[];
    readonly highlight: CategoryHighlight;
    readonly parentCategory?: Category;

    constructor(rawCategory: GetCategoryResponseItem, parentCategory?: Category) {
        this.categoryID = rawCategory.categoryID;
        this.nameEN = rawCategory.nameEN;
        this.nameLocal = rawCategory.nameLocal;
        this.highlight = rawCategory.highlight;

        this.parentCategory = parentCategory;
        this.subCategories = (rawCategory.subCategories || []).map(item => new Category(item, this));
    }

    public static isContainHighlight(item: Category) {
        return item.highlight && (item.highlight.nameEN || item.highlight.nameLocal);
    }

    public static getCategoryHighlightChain(item: Category): CategoryChain {
        if (!item.subCategories || item.subCategories.length === 0) {
            return Category.isContainHighlight(item) ? [item] : [];
        }

        let subCategoryHighlight: CategoryChain = [];
        for (const subItem of item.subCategories) {
            subCategoryHighlight = Category.getCategoryHighlightChain(subItem);
            if (subCategoryHighlight.length > 0) {
                break;
            }
        }
        return [item, ...subCategoryHighlight];
    }

}